import React, { useCallback, useEffect, useContext } from 'react';
import ReactFlow, {
  addEdge,
  useNodesState,
  useEdgesState,
  Background,
  BackgroundVariant,
  ReactFlowProvider,
  useStoreApi,
} from 'reactflow';

import 'reactflow/dist/style.css';
import './style.css';
import { makeApiCall } from '../../../config';
import { successToaster, ErrorToaster } from '../../../utils/toaster';
import { initialEdges, initialNodes } from './nodes-and-edges';
import AuthContext from "../../../context/AuthContext";
import FlowChart from '../../../components/FlowChart';

const MIN_DISTANCE = 150;

const Flow = () => {
  const store = useStoreApi();
  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);
  const {userInfo, enableToaster} = useContext(AuthContext);
  useEffect(() => {
    async function getFlows() {
      try {
        const res = await makeApiCall("/api/v1/admin/get/flow", "get", null, {userId: userInfo._id, hostname: userInfo.defaultURL});
        setNodes(res?.data?.nodesArray);
        console.log("get flow",res);
        setEdges(res?.data?.edgesArray);
        enableToaster && successToaster(res.message);
        return;
      } catch (error) {
        // ErrorToaster("something went wrong");
        console.log("error occurred in getFlows", error);
        return;
      }
    }
    getFlows();
  }, []);

  const onConnect = useCallback(
    (params) => setEdges((eds) => addEdge(params, eds)),
    [setEdges],
  );
  return (<>
  {nodes.length != 0 && edges.length != 0 &&(
    <FlowChart nodes={nodes} edges={edges} onNodesChange={onNodesChange} onEdgesChange={onEdgesChange} onConnect={onConnect}/>
  )}
  
  </>
  );
};

export default () => (
  <ReactFlowProvider>
    <div style={{ width: '77vw', height: '70vh' }}>
    <Flow />
    </div>
  </ReactFlowProvider>
);
